import React from "react";
import PageHeader from "../../PageHeader";
import ViewTotalApplication from "./ViewTotalApplication";
import { ReactComponent as RegistrationLinkIcon } from "../../../images/registrationlinkimage/registrationlinkimage.svg";
import { ReactComponent as AddIcon } from "../../../images/pageheadingicon/addicon.svg";
import useStyles from "../../../../styles";
import { ReactComponent as BackIcon } from "../../../images/pageheadingicon/backicon.svg";
import { Button } from "@material-ui/core";
function GenerateRegistrationLink() {
  const classes = useStyles();
  const Heading = [
    {
      id: 1,
      pageicon: <RegistrationLinkIcon />,
      mainheading: "View Application",
      addbtntext: "Back",
      addbtnicon: <BackIcon />,
      addbtnstyle: "transparentbtn",
      path: "/admin/registrationlink",
      // subhead: "Want to Add in Bulk ? ?",
      // downloadlink: "Download bulk Sample Files",
      // addbtntext: "Generate New Registration Link",
      // addbtnicon: <AddIcon />,
      // addbtnstyle: "bluebtn",
      // path: "/admin/generateregistrationlink",
    },
  ];
  return (
    <div className={`${classes.p1} ${classes.pb0}`}>
      <PageHeader Heading={Heading} />
      <ViewTotalApplication />
      {/* <div
        className={`${classes.w100} ${classes.dflex} ${classes.justifyflexend}`}
      >
        <Button
          variant="contained"
          color="primary"
          className={`${classes.bluebtn} ${classes.my0_5}`}
          onClick={()=>console.log('clicked')}
        >
          Allocate For Branch
        </Button>
      </div> */}
    </div>
  ); 
}
export default GenerateRegistrationLink;
